// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/iconfont/iconfont.css'
import Axios from 'axios'
import API from './api/api'

Vue.use(ElementUI)

Vue.config.productionTip = false

Vue.prototype.$axios = Axios
Vue.prototype.$axios.defaults.baseURL = '/my_api_proxy'
Vue.prototype.bus = new Vue()
Vue.prototype.$api = API
Vue.prototype.$post = Vue.prototype.$api.post

router.beforeEach((to, from, next) => {
    next();
})

new Vue({
    el: '#app',
    router,
    render: h => h(App),
    components: {App},
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js